// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import * as strings from "./strings.json";
import * as commands from "./commands.json";
import * as errors from "./errors.json";
export { strings, commands, errors };
